export default __webpack_public_path__ + "static/media/share.8e1b17f0.png";